import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { FilterSelectionProps } from "models/propTypes/filterPropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import useFilterContext from "./context/useFilterContext";
import GenericForm from "../forms/genericForm";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import useFilterFieldTraversal from "./useFilterFieldTraversal";

function FilterSelection<T extends Record<string, any>>(props: FilterSelectionProps<T>) {
  const filterFormRef = React.useRef<FormHandles>(null);

  const { setFilter, filter } = useFilterContext<T>();
  const { hasAnyNonHiddenFieldSelected } = useFilterFieldTraversal<T>(filter);

  const onFormUpdate = (values: T) => {
    setFilter(values);
  };

  const form = React.useMemo(
    () => (
      <GenericForm<T>
        formRef={filterFormRef}
        defaultValues={filter ?? ({} as T)}
        fields={props.filterFields}
        onFormUpdate={onFormUpdate}
        hideErrorBubble
        hideSuccess
        asRemovableValues
        removeAllButtonText={TranslationKeys.Common.ClearFilter}
        onClickClearAll={props.onClickClearAll}
      />
    ),
    [filter, props.filterFields]
  );

  const hasNonHiddenValues = React.useMemo(() => {
    return hasAnyNonHiddenFieldSelected(props.filterFields);
  }, [hasAnyNonHiddenFieldSelected, props.filterFields]);

  return hasNonHiddenValues ? (
    <Grid container spacing={2} className={cssExports.filterSelectionContainer}>
      <Grid item className={cssExports.smallTitle}>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Filter)}
      </Grid>
      <Grid item xs>
        {form}
      </Grid>
    </Grid>
  ) : (
    <></>
  );
}

export default FilterSelection;
